import React, { Fragment, useEffect, useState, useRef } from 'react'
import vesselQueries from '../../queries/vesselQueries';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import BreadCrumbs from '../../components/BreadCrumbs';
import { RouteConstant } from '../../routes/RouteConstant';
import { setHeaderText, setLoader } from '../../redux/reducers/optionsReducers';
import Loader from '../../components/Loader';
import { Button, Modal, ModalBody, ModalContent, ModalHeader, Popover, PopoverContent, PopoverTrigger, useDisclosure } from '@nextui-org/react';
import { useNavigate } from 'react-router-dom';
import { setMaster, setUser, setVessel } from '../../redux/reducers/masterReducers';
import { setPage } from '../../redux/reducers/paginationReducers';
import toast from 'react-hot-toast';
import { VesselEditFormData } from '../../data/VesselForm';
import DrawerComponent from '../../components/DrawerComponent';
import { 
  Ship, 
  Calendar, 
  Clock, 
  Anchor, 
  Fuel, 
  BarChart3, 
  Users, 
  FileText,
  Eye,
  Waves,
  Settings,
  History,
  Star,
  ArrowRight,
  Sparkles,
  Trash2,
  AlertTriangle,
  X,
  AlertTriangleIcon,
  ShieldIcon,
  TrashIcon,
  Crown,
  XCircle
} from 'lucide-react';
import { useApi } from '../../components/ApiProvider'

const breadcrumb = [
    {
        label: "Vessels",
        path: RouteConstant.VESSEL,
        roles: ["SADMIN"]
    },
    {
      label: "Vessel Details",
      roles: ["SADMIN"]
    }
]

const VesselDetailsScreen = () => {

    const [result, setResult] = useState({})

    const vessel = useSelector((state)=> state.master.vessel)

    const navigate = useNavigate()

    const dispatch = useDispatch()
    const master = useSelector((state)=> state.master)
    const loader = useSelector((state)=> state.options.loader)

    const { apiData } = useApi();

    const vesselView = vesselQueries.useVesselMutationView(
        (res)=>{
            dispatch(setLoader(false))
            setResult(res?.data)
            dispatch(setHeaderText(`Vessel -  ${res?.data?.name}`))
        }
    )
    
    useEffect(() => {
        dispatch(setLoader(true))
        vesselView.mutateAsync(vessel.id)
    }, [apiData]);
    
    const updateMaster = vesselQueries.useVesselMutationUpdate(
        (res)=>{
            if(res?.message === "Error"){
                {res?.error?.map((error, index) => (
                    Object?.values(error).map((errorMessage, innerIndex) => (
                        toast.error(errorMessage)
                    ))
                ))}
                return
            }
            if(res?.message=== "Success"){
                toast.success("Successfully updated vessel")
                vesselView.mutateAsync(master.id)
            }
        }
    )

    const handleInspection =()=>{
        dispatch(setMaster({
            id: result.id,
            header: result.name
          }
        ))
        dispatch(setVessel({
          id: result?.id,
          name: result?.name,
          imo: result?.imo,
          built: result?.built,
          type: result?.type,
          dwt: result?.dwt
        }))
        dispatch(setHeaderText(`Vessel : ${result?.name}`))
        navigate(RouteConstant.INSPECTIONHISTORY)
    }

    const cargoTypes = [
        { label: 'Chemical', value: result?.chemical, color: 'from-purple-400 to-purple-600', icon: '🧪' },
        { label: 'Oil', value: result?.oil, color: 'from-amber-400 to-orange-600', icon: '🛢️' },
        { label: 'LNG', value: result?.lng, color: 'from-blue-400 to-cyan-600', icon: '❄️' },
        { label: 'LPG', value: result?.lpg, color: 'from-red-400 to-rose-600', icon: '🔥' }
    ].filter(type => type.value === 'YES');

const getStatusInfo = (sub) => {
  if (sub === 'Premium') {
    return {
      label: 'Premium',
      icon: <Crown className="w-4 h-4 text-yellow-300" />,
      bg: 'bg-yellow-300/10',
      text: 'text-yellow-300',
    };
  } else if (sub === 'Trial') {
    return {
      label: 'Trial',
      icon: <Clock className="w-4 h-4 text-cyan-400" />,
      bg: 'bg-cyan-400/10',
      text: 'text-cyan-400',
    };
  } else {
    return {
      label: 'Expired',
      icon: <XCircle className="w-4 h-4 text-red-400" />,
      bg: 'bg-red-400/10',
      text: 'text-red-400',
    };
  }
};

    const status = getStatusInfo(result?.user?.subscription);

    if(loader){
        return <Loader />
    }

  return (
    <Fragment>
        <div className='mb-8'>
            <BreadCrumbs data={breadcrumb} />
        </div>

        <div className="min-h-screen p-1">
            <div className="">
                
                {/* Hero Section */}
                <div className="relative overflow-hidden bg-primaryGradient rounded-[2rem] shadow-2xl mb-10">
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-purple-600/20"></div>
                    <div className="absolute -top-4 -right-4 w-96 h-96 bg-gradient-to-r from-purple-400/10 to-pink-400/10 rounded-full blur-3xl"></div>
                    <div className="relative p-10">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center space-x-6">
                                <div className="relative">
                                    <div className="bg-white/20 backdrop-blur-lg rounded-3xl p-6 border border-white/20">
                                        <Ship className="h-16 w-16 text-white drop-shadow-xl" />
                                    </div>
                                </div>
                                <div>
                                    <h1 className="text-3xl font-semibold text-white mb-2 tracking-tight">{result?.name}</h1>
                                    <div className="flex items-center space-x-4">
                                        <div className={`inline-flex items-center gap-1 px-4 py-2 rounded-md ${status.bg} ${status.text} text-sm font-medium`}>
                                            {status.icon}
                                            {status.label}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="text-right">
                                <p className="text-white/60 text-sm font-medium">IMO Registry</p>
                                <p className="text-xl font-bold text-white mt-1">{result?.imo_no}</p>
                                <div className="mt-4 flex space-x-3">
                                    <DrawerComponent vesselEdit edit data={result} inputFields={VesselEditFormData} btnName="Update Vessel" header="Update Vessel" entityForm={updateMaster}  />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main Grid */}
                <div className="grid grid-cols-1 xl:grid-cols-4 gap-8">
                    
                    {/* Left Column - Main Content */}
                    <div className="xl:col-span-3 space-y-8">
                        
                        {/* Vessel Specifications */}
                        <div className="bg-white/80 backdrop-blur-xl rounded-[2rem] shadow-xl border border-white/20 p-8">
                            <div className="flex items-center justify-between mb-8">
                                <div className="flex items-center space-x-4">
                                    <div className="bg-gradient-to-r from-blue-500 to-cyan-500 rounded-2xl p-4">
                                        <Anchor className="h-7 w-7 text-white" />
                                    </div>
                                    <h2 className="text-3xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
                                        Vessel Specifications
                                    </h2>
                                </div>
                                <div className="bg-gradient-to-r from-green-100 to-emerald-100 rounded-full px-4 py-2">
                                    <span className="text-green-700 font-semibold text-sm">Verified</span>
                                </div>
                            </div>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">                                
                                <div className="group bg-gradient-to-r from-slate-50 to-green-50 rounded-2xl p-6 border border-slate-200 hover:border-green-300 hover:shadow-lg transition-all duration-300 hover:scale-[1.02]">
                                    <div className="flex items-center space-x-3 mb-3">
                                        <div className="bg-green-500 rounded-full p-2">
                                            <BarChart3 className="h-5 w-5 text-white" />
                                        </div>
                                        <p className="text-sm text-gray-500 uppercase tracking-wider font-bold">Deadweight Tonnage</p>
                                    </div>
                                    <p className="text-2xl font-bold text-gray-800 mb-2">{result?.dwt}</p>
                                    <p className="text-sm text-gray-500">Metric Tons</p>
                                </div>
                                
                                <div className="group bg-gradient-to-r from-slate-50 to-purple-50 rounded-2xl p-6 border border-slate-200 hover:border-purple-300 hover:shadow-lg transition-all duration-300 hover:scale-[1.02]">
                                    <div className="flex items-center space-x-3 mb-3">
                                        <div className="bg-purple-500 rounded-full p-2">
                                            <Calendar className="h-5 w-5 text-white" />
                                        </div>
                                        <p className="text-sm text-gray-500 uppercase tracking-wider font-bold">Year Built</p>
                                    </div>
                                    <p className="text-2xl font-bold text-gray-800 mb-2">{result?.built}</p>
                                    <p className="text-sm text-gray-500">Construction Year</p>
                                </div>
                            </div>
                        </div>

                        {/* Cargo Capabilities */}
                        <div className="bg-white/80 backdrop-blur-xl rounded-[2rem] shadow-xl border border-white/20 p-8">
                            <div className="flex items-center justify-between mb-8">
                                <div className="flex items-center space-x-4">
                                    <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl p-4">
                                        <Fuel className="h-7 w-7 text-white" />
                                    </div>
                                    <h2 className="text-3xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
                                        Cargo Capabilities
                                    </h2>
                                </div>
                                <div className="text-sm text-gray-500 font-medium">
                                    {cargoTypes.length} Certified Types
                                </div>
                            </div>
                            
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                                {cargoTypes.map((type, index) => (
                                    <div key={index} className={`bg-gradient-to-br ${type.color} rounded-2xl p-6 text-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 group`}>
                                        <div className="text-4xl mb-3">{type.icon}</div>
                                        <p className="font-bold text-white text-lg mb-2">{type.label}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Right Sidebar */}
                    <div className="xl:col-span-1 space-y-6">
                        
                        {/* Last Update Card */}
                        <div className="bg-white/80 backdrop-blur-xl rounded-[2rem] shadow-xl border border-white/20 p-6">
                            <h3 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
                                <History className="h-5 w-5 mr-2 text-blue-500" />
                                Recent Activity
                            </h3>
                            
                            <div className="space-y-4">
                                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-4 border border-blue-100">
                                    <div className="flex items-center space-x-3 mb-2">
                                        <div className="bg-blue-500 rounded-full p-2">
                                            <Users className="h-4 w-4 text-white" />
                                        </div>
                                        <div>
                                            <p className="text-xs text-gray-500 font-medium">Last updated by</p>
                                            <p className="font-bold text-gray-800">{result?.updatedBy?.fname} {result?.updatedBy?.lname}</p>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-4 border border-green-100">
                                    <div className="flex items-center space-x-3 mb-2">
                                        <div className="bg-green-500 rounded-full p-2">
                                            <Clock className="h-4 w-4 text-white" />
                                        </div>
                                        <div>
                                            <p className="text-xs text-gray-500 font-medium">Last update time</p>
                                            <p className="font-bold text-gray-800">{moment(result?.updatedAt).format("MMM DD, YYYY")}</p>
                                            <p className="text-xs text-gray-500">{moment(result?.updatedAt).format("hh:mm A")}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Action Cards */}
                        <div className="space-y-4">
                            <Button 
                            onClick={handleInspection} 
                            className='w-full bg-gradient-to-r from-emerald-500 to-teal-600 text-white font-semibold shadow-xl hover:shadow-2xl transition-all duration-300 py-6 rounded-xl hover:scale-[1.02] border border-emerald-400/50' 
                            size='lg'
                            >
                                <div className="flex items-center justify-between w-full">
                                    <div className="flex items-center">
                                        <Eye className="h-5 w-5 mr-3" />
                                        <span>Inspection History</span>
                                    </div>
                                    <ArrowRight className="h-5 w-5" />
                                </div>
                            </Button>
                            <DeleteVesselButton result={result} />
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
  )
}

export default VesselDetailsScreen



const DeleteVesselButton = ({result}) => {

    const navigate = useNavigate()

    const {isOpen, onOpen, onOpenChange} = useDisclosure();
    const [isLoading, setIsLoading] = useState(false);

    const { setApiDataAndNotify } = useApi()
    
    const handleOpen = () => {
        onOpen()
    };

    const handleCancel = () => {
        onOpenChange()
    };

    const deleteVessel = vesselQueries.useVesselMutationDelete(
        (res)=>{
        }
    )

    const handleConfirmDelete = async () => {
        setIsLoading(true);
        try {
            const response = await deleteVessel.mutateAsync(result?.id);
            setApiDataAndNotify(new Date())
            navigate(RouteConstant.VESSEL);
            toast.success("Vessel deleted successfully");
        } catch (error) {
            console.error('Delete failed:', error);
        } finally {
            setIsLoading(false);
        }
    };


    return(
        <Fragment>
            <Button
            onClick={handleOpen}
            className='w-full bg-gradient-to-r from-pink-500 to-orange-600 text-white font-semibold shadow-xl hover:shadow-2xl transition-all duration-300 py-6 rounded-xl hover:scale-[1.02] border border-emerald-400/50' 
            size='lg'
            >
                <div className="flex items-center w-full">
                    <Trash2 className="h-5 w-5 mr-3" />
                    <span>Delete Vessel</span>
                </div>
            </Button>
            <Modal
            isDismissable={false}
            backdrop="opaque"
            size="xl"
            scrollBehavior="inside"
            isOpen={isOpen} 
            onOpenChange={onOpenChange}
            hideCloseButton
            classNames={{
            backdrop: "bg-gradient-to-t from-zinc-900 to-zinc-900/10 backdrop-opacity-20",
            base: "min-h-[300px] overflow-auto bg-transparent",
            }}
            >
                <ModalContent>
                {(onClose) => (
                    <Fragment>
                        <ModalBody>
                            <div className="bg-white rounded-2xl overflow-hidden border border-red-100">
                                <div className="bg-gradient-to-r from-red-50 to-orange-50 px-6 py-4 border-b border-red-100">
                                    <div className="flex items-center justify-between">
                                    <div className="flex items-center">
                                        <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center mr-3">
                                        <AlertTriangle className="h-5 w-5 text-red-600" />
                                        </div>
                                        <div>
                                        <h3 className="font-semibold text-gray-900 text-sm">Confirm Deletion</h3>
                                        <p className="text-xs text-gray-600">This action cannot be undone</p>
                                        </div>
                                    </div>
                                    <Button
                                        variant="ghost"
                                        size="sm"
                                        onClick={handleCancel}
                                        className="h-8 w-8 p-0 hover:bg-red-100 rounded-full"
                                    >
                                        <X className="h-4 w-4 text-gray-500" />
                                    </Button>
                                    </div>
                                </div>

                                <div className="px-6 py-5">
                                    <div className="mb-4">
                                    <p className="text-sm text-gray-700 leading-relaxed">
                                        Are you sure you want to delete this vessel?
                                        This action will permanently remove:
                                    </p>
                                    <ul className="mt-3 space-y-1 text-xs text-gray-600">
                                        <li className="flex items-center">
                                        <div className="w-1.5 h-1.5 bg-red-400 rounded-full mr-2"></div>
                                        All vessel data and information
                                        </li>
                                        <li className="flex items-center">
                                        <div className="w-1.5 h-1.5 bg-red-400 rounded-full mr-2"></div>
                                        Associated inspection records
                                        </li>
                                        <li className="flex items-center">
                                        <div className="w-1.5 h-1.5 bg-red-400 rounded-full mr-2"></div>
                                        Related documents and files
                                        </li>
                                    </ul>
                                    </div>
                                </div>

                                <div className="px-6 py-4 bg-gray-50 border-t border-gray-100">
                                    <div className="flex space-x-3">
                                    <Button
                                        variant="outline"
                                        onClick={handleCancel}
                                        className="flex-1 border-gray-300 text-gray-700 hover:bg-gray-100 transition-colors duration-200"
                                        disabled={isLoading}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        onClick={handleConfirmDelete}
                                        disabled={isLoading}
                                        className="flex-1 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-medium shadow-lg hover:shadow-xl transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        {isLoading ? (
                                        <div className="flex items-center">
                                            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                                            Deleting...
                                        </div>
                                        ) : (
                                        <div className="flex items-center">
                                            <Trash2 className="h-4 w-4 mr-2" />
                                            Delete Vessel
                                        </div>
                                        )}
                                    </Button>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                    </Fragment>
                )}
                </ModalContent>
            </Modal>
        </Fragment>
    )
}